var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcedMatcha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 288 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#29abe2;stroke:#ff7bac;}.cls-1,.cls-2,.cls-3,.cls-4{stroke-linecap:round;stroke-linejoin:round;}.cls-1,.cls-2{stroke-width:3px;}.cls-2{fill:#c69c6d;stroke:#c69c6d;}.cls-3{fill:#74a12e;stroke:#46680b;stroke-width:5px;}.cls-4,.cls-5{fill:none;}.cls-4{stroke:#fff;stroke-width:8px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 129.5,
    y1: 221.5,
    x2: 174.5,
    y2: 21.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.5,
    y: 118,
    width: 205,
    height: 7,
    transform: "translate(0.11 243.14) rotate(-77.32)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "108 234 90 78 198 78 180 234 108 234"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "123 91 105 91 114 172"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 288,
    height: 288
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcedMatcha);
export default __webpack_public_path__ + "static/media/iced-matcha.a58330b1b982df39b9539eab1cd6a2e3.svg";
export { ForwardRef as ReactComponent };